<template>
  <div>
    <div class="p-4 md:p-[50px] lg:p-[100px]">
      <!-- Title Section -->
      <div class="mb-6 md:mb-12 text-start">
        <h1 class="text-[24px] md:text-[32px] lg:text-[36px] font-semibold">
          {{ getLocalized("title") }}
        </h1>
      </div>

      <!-- Content Grid -->
      <div>
        <div>
          <p
            class="text-[16px] lg:text-[20px]"
            v-html="formatContent(experience)"
          ></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    experience: { type: String, required: true },
  },

  data() {
    return {
      // Language options and translations
      translations: {
        title: {
          en: "What TURBOTECH have done?",
          kh: "តើ ធើបូថេក បានធ្វើអ្វីខ្លះ?",
        },
      },

      // Default language is from localStorage or 'en' if not set
      currentLang: localStorage.getItem("language") || "en",
    };
  },

  computed: {
    // Method to get the localized text based on the current language
    getLocalized() {
      return (key) => {
        return this.translations[key]
          ? this.translations[key][this.currentLang]
          : key;
      };
    },
  },
  methods: {
    formatContent(content) {
      if (!content) return ""; // Return empty if no content

      // Trim any extra spaces around the content
      let formattedContent = "";
      let tempContent = content.trim();

      // Split content by period (.) or Khmer full stop (។)
      const sentences = tempContent.split(/(?<=\.|។)/); // Split by period or Khmer full stop

      let line = "";
      sentences.forEach((sentence) => {
        const sentenceWithDot = sentence.trim(); // Ensure sentence ends with a period or full stop

        // If line length is under 500 characters, add to the current line
        if (line.length + sentenceWithDot.length <= 500) {
          line += sentenceWithDot + " "; // Add space after sentence
        } else {
          // Otherwise, add the current line to formattedContent and start a new line
          formattedContent += line.trim() + "<br><br>";
          line = sentenceWithDot + " "; // Start new line with the current sentence
        }
      });

      // Add any remaining content in the last line
      if (line.length > 0) {
        formattedContent += line.trim();
      }

      return formattedContent; // Return the formatted content with <br> tags
    },
  },
};
</script>
